import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Version } from '../interfaces/version';

@Injectable({ providedIn: 'root' })
export class SystemDataService {
  constructor(public http: HttpClient) {}

  getVersionInfo(): Promise<Version> {
    return this.http
      .get('/api/system/version')
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  public extractData(res: any) {
    return res;
  }

  public handleError(errorResponse: HttpErrorResponse | any) {
    let fullErrorMessage: string;
    if (errorResponse instanceof HttpErrorResponse) {
      const error = errorResponse.error || JSON.stringify(errorResponse);
      fullErrorMessage = `${errorResponse.status} - ${errorResponse.statusText || ''} ${error}`;
    } else {
      fullErrorMessage = errorResponse.message ? errorResponse.message : errorResponse.toString();
    }
    console.error(fullErrorMessage);
    return Promise.reject(fullErrorMessage);
  }
}
